import { useEffect } from 'react';
import { useAppTranslation } from './useAppTranslation';
import { restoreLegalScroll } from './restoreLegalScroll';
export function useLegalDocument() {
    const { i18n } = useAppTranslation();
    const language = (i18n.resolvedLanguage || i18n.language).split('-')[0];
    useEffect(() => {
        let cleanup = restoreLegalScroll();
        const onShow = () => { cleanup(); cleanup = restoreLegalScroll(); };
        window.addEventListener('pageshow', onShow);
        return () => { cleanup(); window.removeEventListener('pageshow', onShow); };
    }, []);
    const remember = () => {
        try {
            sessionStorage.setItem(`mybake:scroll:${window.location.href}`, String(window.scrollY));
        }
        catch (_a) { }
    };
    const hrefFor = (href) => {
        const localized = href.replace(/\/pl\/(kontakt|regulamin|polityka-prywatnosci|DPA)(?=[?#]|$)/, `/${['pl', 'ru', 'uk', 'en'].includes(language) ? language : 'pl'}/$1`);
        const source = typeof window !== 'undefined' ? window.location.href : '';
        return `${localized}${localized.includes('?') ? '&' : '?'}returnLang=${encodeURIComponent(language)}&returnTo=${encodeURIComponent(source)}&returnDepth=1`;
    };
    return { hrefFor, remember };
}
